import { RAPPI_PROVIDER } from "constants/rappi";
import fetchUtils from "utils/fetchUtils";

const getAllFiles = async () => {
	try {
		const { data } = await fetchUtils.getCustom(`/b2b/invoicing/scape/invoicing-putters/file_tree/${RAPPI_PROVIDER}`);
		return data.resource;
	} catch (error) {
		throw error;
	}
};

const postFormFile = async (body: Object) => {
	try {
		const response = await fetchUtils.post(`/b2b/v2/invoicing/scape/invoicing-putters/upload`, body, { token: true });
		return response;
	} catch (error) {
		throw error;
	}
}

const sendPutFile = async (body: Object, url:string) => {
	try {
		const response = await fetchUtils.putCustom(url, body);
		return response;
	} catch (error) {
		throw error;
	}
}

export { getAllFiles, postFormFile, sendPutFile };
